module.exports = __webpack_public_path__ + "img/approve-bg.ce02d8ca.png";